import { PageTypeId } from '../../const';
import { navigationCodes } from '../../../../data/translations/navigationCodes';
import { CommonNavigationStrategy } from '../common/strategy';

export class EmployerUserStrategy extends CommonNavigationStrategy {
	override getSchema = () => {
		const baseSchema = super.getSchema();

		return {
			...baseSchema,
			userNavigationItems: baseSchema.userNavigationItems.map(i => {
				if (i.pageTypeId === PageTypeId.EmployerList) {
					return { ...i, titleCode: navigationCodes.employerMyOrganization };
				}
				return i;
			}),
		};
	};
}
